var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('datepicker',_vm._b({staticClass:"az_base_datepicker",class:[{'ftr': _vm.isFilter}, _vm.datepickerClass],attrs:{"input-class":{'az_base_inp': true, ..._vm.computedInputClass},"language":_vm.lang[_vm.$i18n.locale],"bootstrap-styling":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'datepicker',{
					'format': 'd.MM.yyyy',
					'full-month-name': true,
					'disabled-dates': {
						to: _vm.disableTo ? new Date() : null,
						from: _vm.disableFrom ? new Date() : null,
					},
					'placeholder': _vm.$t('deadlineDate'),
					'monday-first': true,
					'clear-button': true,
					'clear-button-icon': 'fa fa-times',
					..._vm.$attrs
				},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }